(() => {
  const cardSelector = '.snize-product[data-original-product-id]';
  const linkSelector = cardSelector + ' a.snize-view-link, ' + cardSelector + ' a.snize-item';
  const spacingName = 'filter_option_a0c439bf7ed19f207869f0e9f181eb31';
  const requests = new Map();
  const states = new WeakMap();

  const spacingKey = (value) => {
    const mm = [...value.matchAll(/([\d.]+)\s*mm/gi)].map((match) => Number(match[1]));
    return mm.length ? mm.join('/') : value.trim().toLowerCase();
  };

  const selectedSpacings = () => {
    const checked = [...document.querySelectorAll('input[name="' + spacingName + '"]:checked')];
    if (checked.length) return [...new Set(checked.map((input) => spacingKey(input.value)))];
    return new URLSearchParams(location.search).getAll('rb_' + spacingName).map(spacingKey);
  };

  const readVariant = (url) => {
    url.searchParams.set('section_id', 'rok-search-variant');
    const key = url.href;
    if (!requests.has(key)) {
      requests.set(key, fetch(key, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error('Variant data unavailable');
          return response.text();
        })
        .then((html) => {
          const data = new DOMParser().parseFromString(html, 'text/html')
            .querySelector('[data-rok-search-variant]');
          if (!data) throw new Error('Variant data unavailable');
          return JSON.parse(data.textContent);
        })
        .catch((error) => {
          requests.delete(key);
          throw error;
        }));
      if (requests.size > 150) requests.delete(requests.keys().next().value);
    }
    return requests.get(key);
  };

  const matchVariant = async (url, seedId, spacings) => {
    const seedUrl = new URL(url);
    seedUrl.searchParams.delete('option_values');
    seedUrl.searchParams.set('variant', seedId);
    const seed = await readVariant(seedUrl);
    if (!seed.variant) throw new Error('Result variant unavailable');
    const index = seed.options.findIndex((option) => /^(hole centers|center-to-center \(hole spacing\))$/i.test(option.name));
    if (index < 0) return seed.variant;
    if (spacings.includes(spacingKey(seed.variant.options[index]))) return seed.variant;
    const choices = seed.options[index].values.filter((value) => spacings.includes(spacingKey(value.name)));
    for (const choice of choices) {
      const optionIds = seed.options.map((option, position) =>
        position === index ? choice.id : option.values.find((value) => value.selected)?.id);
      if (optionIds.some((id) => !id)) continue;
      const candidateUrl = new URL(url);
      candidateUrl.searchParams.delete('variant');
      candidateUrl.searchParams.set('option_values', optionIds.join(','));
      const candidate = await readVariant(candidateUrl);
      if (candidate.variant && spacings.includes(spacingKey(candidate.variant.options[index])) &&
          candidate.variant.options.every((value, position) => position === index || value === seed.variant.options[position])) {
        return candidate.variant;
      }
    }
    const error = new Error('No variant matches this finish and hole spacing');
    error.code = 'NO_MATCH';
    throw error;
  };

  const applyVariant = (link, card, url, variant) => {
    url.searchParams.delete('option_values');
    url.searchParams.set('variant', variant.id);
    const href = url.pathname + url.search + url.hash;
    if (link.getAttribute('href') !== href) link.setAttribute('href', href);
    if (variant.image) {
      card.querySelectorAll('.snize-item-image').forEach((image) => {
        if (image.getAttribute('src') !== variant.image) image.setAttribute('src', variant.image);
        image.removeAttribute('srcset');
      });
    }
    const price = card.querySelector('.snize-price');
    if (price && variant.price && price.textContent !== variant.price) price.textContent = variant.price;
    const compare = card.querySelector('.snize-discounted-price');
    if (compare && variant.price) {
      if (compare.textContent !== (variant.comparePrice || '')) compare.textContent = variant.comparePrice || '';
      compare.hidden = !variant.comparePrice;
    }
  };

  const updateLink = (link) => {
    const card = link.closest(cardSelector);
    const id = card?.id.match(/^snize-(?:ac-)?product-(\d+)$/)?.[1];
    if (!id || id === card.dataset.originalProductId) return null;
    const href = link.getAttribute('href');
    if (!href) return null;
    const url = new URL(href, location.href);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) return null;
    // Instant suggestions are independent of filters on the current results page.
    const spacings = card.id.startsWith('snize-ac-product-') ? [] : selectedSpacings();
    const key = card.id + '|' + url.pathname + '|' + spacings.join(',');
    const previous = states.get(link);
    if (previous?.key === key) {
      if (!spacings.length) previous.variant = { id: url.searchParams.get('variant') || id };
      if (previous.variant) applyVariant(link, card, url, previous.variant);
      return previous;
    }
    const state = { key, variant: null, pending: null };
    states.set(link, state);
    if (card.dataset.rokNoMatchingVariant) {
      card.hidden = false;
      card.style.removeProperty('display');
      delete card.dataset.rokNoMatchingVariant;
    }
    if (!spacings.length) {
      state.variant = { id: url.searchParams.get('variant') || id };
      applyVariant(link, card, url, state.variant);
      link.removeAttribute('aria-busy');
      link.removeAttribute('aria-disabled');
      return state;
    }
    link.setAttribute('aria-busy', 'true');
    state.pending = matchVariant(url, id, spacings).then((variant) => {
      if (!link.isConnected || states.get(link) !== state) return;
      state.variant = variant;
      applyVariant(link, card, url, variant);
      link.removeAttribute('aria-busy');
      link.removeAttribute('aria-disabled');
    }).catch((error) => {
      if (states.get(link) !== state) return;
      if (error.code === 'NO_MATCH') {
        card.dataset.rokNoMatchingVariant = 'true';
        card.hidden = true;
        card.style.display = 'none';
      }
      link.removeAttribute('aria-busy');
      link.setAttribute('aria-disabled', 'true');
    });
    return state;
  };

  const sinkStates = new WeakMap();
  const sinkLinkSelector = 'a.snize-view-link[href*="/products/rok-sink-rvg"]';
  const updateSinkImage = (link) => {
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/products\/rok-sink-rvg(?:1016|1022)$/.test(url.pathname)) return;
    const id = url.searchParams.get('variant');
    let state = sinkStates.get(link);
    if (!state) {
      state = { id: null, variant: null, images: [...link.querySelectorAll('.snize-item-image')].map(image => ({ image, src: image.getAttribute('src'), srcset: image.getAttribute('srcset'), alt: image.getAttribute('alt') })) };
      sinkStates.set(link, state);
    }
    const apply = () => {
      state.images.forEach(({ image, src, srcset, alt }) => {
        const selected = state.variant;
        const nextSrc = selected?.image || src;
        const nextAlt = selected ? [link.getAttribute('aria-label'), ...selected.options].filter(Boolean).join(' — ') : alt;
        if (nextSrc && image.getAttribute('src') !== nextSrc) image.setAttribute('src', nextSrc);
        if (nextAlt && image.getAttribute('alt') !== nextAlt) image.setAttribute('alt', nextAlt);
        if (selected || !srcset) image.removeAttribute('srcset');
        else if (image.getAttribute('srcset') !== srcset) image.setAttribute('srcset', srcset);
      });
    };
    if (state.id === id) {
      if (state.variant) apply();
      return;
    }
    state.id = id;
    state.variant = null;
    if (!id) { apply(); return; }
    readVariant(url).then(data => {
      if (!link.isConnected || state.id !== id || new URL(link.href).searchParams.get('variant') !== id) return;
      if (!data.variant?.image || String(data.variant.id) !== id) return;
      state.variant = data.variant;
      apply();
    }).catch(() => { if (state.id === id) state.id = null; });
  };

  let queued = false;
  const refresh = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => {
      queued = false;
      document.querySelectorAll(linkSelector).forEach(updateLink);
      document.querySelectorAll(sinkLinkSelector).forEach(updateSinkImage);
    });
  };

  const start = () => {
    refresh();
    new MutationObserver(refresh).observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['href', 'id', 'data-original-product-id'],
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('.snize-product-filters-checkbox')) refresh();
  });
  for (const name of ['pointerdown', 'focusin', 'contextmenu']) {
    document.addEventListener(name, (event) => {
      const link = event.target.closest?.(linkSelector);
      if (link) updateLink(link);
    }, true);
  }
  const navigate = (event) => {
    let instantCard = event.target.closest?.(cardSelector + '[id^="snize-ac-product-"]');
    if (event.type === 'keydown') {
      if (event.key !== 'Enter' && !(event.key === ' ' && instantCard)) return;
      if (!instantCard && event.target.getAttribute('aria-controls') === 'snize-instant-search-results' &&
          event.target.getAttribute('aria-expanded') === 'true') {
        const active = document.getElementById(event.target.getAttribute('aria-activedescendant'));
        if (active?.matches(cardSelector + '[id^="snize-ac-product-"]')) instantCard = active;
      }
      if (!instantCard) return;
    }
    const link = event.target.closest?.(linkSelector) || instantCard?.querySelector('a.snize-item');
    if (!link || event.target.closest('button')) return;
    const state = updateLink(link);
    // Searchanise's suggestion handler uses its original URL rather than the anchor.
    if (instantCard && state?.variant) {
      if (event.type === 'auxclick' && event.button !== 1) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (event.type === 'auxclick' || event.ctrlKey || event.metaKey || event.shiftKey) window.open(link.href, '_blank', 'noopener');
      else location.assign(link.href);
      return;
    }
    if (!state || state.variant) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    state.pending?.then(() => {
      if (state.variant && states.get(link) === state) {
        if (event.type === 'auxclick' || event.ctrlKey || event.metaKey || event.shiftKey) window.open(link.href, '_blank', 'noopener');
        else location.assign(link.href);
      }
    });
  };
  document.addEventListener('click', navigate, true);
  document.addEventListener('auxclick', navigate, true);
  document.addEventListener('keydown', navigate, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
